import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en';
import es from './locales/es';

Vue.use(VueI18n);

const messages = {
  en,
  es,
};

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  fallbackLocale: 'en', // Idioma de respaldo en caso de que falten traducciones
  messages, // Carga los mensajes de traducción
});

export default i18n;